import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import { Fetch } from '@studiometa/ui';
import Figure from './Figure.js';
import Navbar from './Navbar/index.js';
import Search from './Search/index.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Blog from './Blog/index.js';
import Toast from './Toast/index.js';
import PopinNewsletter from './PopinNewsletter.js';
import Product from './Product/index.js';
import Collection from './Collection/index.js';
import LanguageModal from './LanguageModal.js';
import QuickBuy from './QuickBuy.js';
import QuickBuyPanel from './QuickBuyPanel.js';
import PriceB2b from './PriceB2b.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      Fetch,
      Product,
      Figure,
      PopinNewsletter,
      Header,
      Navbar,
      Cart,
      LanguageModal,
      Search,
      Blog,
      Toast,
      Collection,
      QuickBuy,
      QuickBuyPanel,
      PriceB2b,
      VariantMedia: (app) =>
        importWhenVisible(() => import('./VariantMedia.js'), 'VariantMedia', app),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}
